import {
  FC, useEffect, useRef, useState
} from 'react'
import cn from 'classnames'
import { GhostButton } from 'common/components/Button/GhostButton'
import { ONE_SECOND_MS } from 'common/constants'
import { Typography, TypographyVariants } from 'common/typography'
import { SNACKBAR_DURATION } from 'features/SnackbarManager/constants'
import styles from './styles.module.sass'

interface ISnackbar {
  message: string
  actionLabel: string
  onAction: (onAfter: () => void) => void
  onTimeout: () => void
  duration?: number
  snackbarStyles?: string
}

export const Snackbar: FC<ISnackbar> = ({
  message,
  actionLabel,
  onAction,
  onTimeout,
  duration = SNACKBAR_DURATION,
  snackbarStyles
}) => {
  const [secondsLeft, setSecondsLeft] = useState(duration / ONE_SECOND_MS)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (secondsLeft === 0) {
      onTimeout()
    } else {
      timeoutRef.current = setTimeout(() => {
        setSecondsLeft((prev) => prev - 1)
      }, ONE_SECOND_MS)
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [secondsLeft])

  const handleActionClick = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    setTimeout(() => {
      onAction(() => setSecondsLeft(duration / ONE_SECOND_MS))
    }, 0)
  }

  return (
    <div className={cn(styles.snackbar, snackbarStyles)}>
      <Typography variant={TypographyVariants.Body_1_Medium} tag="p">
        {message}
      </Typography>
      <Typography variant={TypographyVariants.Body_1_Medium} tag="p">
        {!!secondsLeft && secondsLeft}
      </Typography>
      <GhostButton
        title={(
          <Typography variant={TypographyVariants.Body_1_Medium} tag="p">
            {actionLabel}
          </Typography>
        )}
        onClick={handleActionClick}
        className={styles.actionButton}
      />
    </div>
  )
}
